import { render } from "./NewProduct.vue?vue&type=template&id=03e116cd&scoped=true"
import script from "./NewProduct.vue?vue&type=script&lang=js"
export * from "./NewProduct.vue?vue&type=script&lang=js"

import "./NewProduct.vue?vue&type=style&index=0&id=03e116cd&lang=scss&scoped=true"

import exportComponent from "/Users/marc.bush/Sites/ensotyres/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03e116cd"]])

export default __exports__